module.exports = __webpack_public_path__ + "static/media/kids.3771652a.jpg";